import { useModelsContext } from "@/providers/models-provider/models-provider";
import {
  addFavouriteModel,
  deleteFavouriteModel,
} from "@/actions/db/favourite";

export const useVoiceCardHeader = () => {
  const { models, setModels } = useModelsContext();

  const toggleFavourite = async (modelId: string, userId: string) => {
    const updatedModels = models.map((model) => {
      if (model.id === modelId) {
        const updatedModel = { ...model, isFavourite: !model.isFavourite };
        if (updatedModel.isFavourite) {
          addFavouriteModel(userId, modelId);
        } else {
          deleteFavouriteModel(userId, modelId);
        }
        return updatedModel;
      }
      return model;
    });
    setModels(updatedModels);
  };

  return { toggleFavourite };
};
